import React, { Component } from 'react';
import ReactDOM, { render} from 'react-dom';
import DialogHOC  from './dialog-hoc';

// const ConfirmDialog = DialogHOC(DialogNested);

module.exports = {
	create: function (cfg, nestedPopup, callback) {
		cfg = cfg || {};

        this._callback = callback;
		if (this.layer) {
			this.destroy();
		}

        const ConfirmDialog = DialogHOC(nestedPopup);
		var mountNode = this.createMountNode();

		this.layer = ReactDOM.render(
			    <ConfirmDialog {...cfg} onHide={this.onHide.bind(this)} onCancel={this.onCancel.bind(this)} onConfirm={this.onConfirm.bind(this)} />,
			mountNode
		);
	},
    onCancel: function() {
        if ('function' == typeof this._callback) {
            this._callback('cancel');
        }
    },
    onConfirm: function(extra) {
        if ('function' == typeof this._callback) {
            this._callback('confirm', extra);
        }
    },
	onHide: function(){
		this.destroy();
	},
	// 创建组件插入的DOM节点
	createMountNode: function() {
		this.mountNode = document.createElement("div");
		$(document.body).append(this.mountNode);
		return this.mountNode;
	},
	destroy : function () {
		ReactDOM.unmountComponentAtNode(this.mountNode);
		$(this.mountNode).remove();
		delete this.layer;
	}
};



// WEBPACK FOOTER //
// ./js/popup/common-popup.js